import { Box, Divider, Drawer, Hidden, Typography } from "@material-ui/core";
import dashboardStyle from "./DashboardStyle";
import DrawerList from "./DrawerList";

const Sidebar = ({ mobileOpen, setMobileOpen }) => {
  const classes = dashboardStyle();

  return (
    <nav className={classes.drawer}>
      <Hidden smUp>
        <Drawer
          className={classes.TemporaryDrawer}
          variant="temporary"
          anchor="left"
          open={mobileOpen}
          onClose={() => setMobileOpen(!mobileOpen)}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <Box p={2} component="span">
            <Typography variant="h5">Material-UI</Typography>
          </Box>
          <Divider />
          <DrawerList />
        </Drawer>
      </Hidden>

      <Hidden xsDown>
        <Drawer
          variant="permanent"
          anchor="left"
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <DrawerList />
        </Drawer>
      </Hidden>
    </nav>
  );
};

export default Sidebar;
